import { Box, styled } from '@mui/material';

export const PreviewVideoPlayerStyle = styled(Box)`
  .shimmer-wrapper {
    width: 100%;
    background: rgba(0, 0, 0, 1);
  }

  ${({ theme }) => theme.breakpoints.up('xs')} {
    .shimmer-wrapper {
      height: 155px;
    }

    & .curriculum-preview-video-player .video-js {
      height: 155px;
      .vjs-control-bar {
        font-size: 8px;
      }
    }

    & .bundle-course-preview-video-player .video-js {
      height: 179px;
      .vjs-control-bar {
        font-size: 8px;
      }
    }

    & .degree-landing-page-video-preview-modal .video-js {
      height: 183px;
      .vjs-control-bar {
        font-size: 8px;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    .shimmer-wrapper {
      height: 365px;
    }

    & .curriculum-preview-video-player .video-js {
      height: 365px;
      .vjs-control-bar {
        font-size: 12px;
      }
    }

    & .bundle-course-preview-video-player .video-js {
      height: 393px;
      .vjs-control-bar {
        font-size: 12px;
      }
    }

    & .degree-landing-page-video-preview-modal .video-js {
      height: 402px;
      .vjs-control-bar {
        font-size: 12px;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    .shimmer-wrapper {
      height: 477px;
    }

    & .banner-preview-video-player .video-js {
      font-size: 12px;
      height: 274px;
    }

    & .banner-preview-video-player .vjs-fullscreen {
      font-size: 16px;
    }

    & .curriculum-preview-video-player .video-js {
      height: 477px;
      .vjs-control-bar {
        font-size: 12px;
      }
    }

    & .curriculum-preview-video-player .vjs-fullscreen .vjs-control-bar {
      font-size: 16px;
    }

    & .bundle-course-preview-video-player .video-js {
      height: 512px;
      .vjs-control-bar {
        font-size: 12px;
      }
    }

    & .bundle-course-preview-video-player .vjs-fullscreen .vjs-control-bar {
      font-size: 16px;
    }

    & .degree-landing-page-video-preview-modal .video-js {
      height: 572px;
      .vjs-control-bar {
        font-size: 12px;
      }
    }

    & .degree-landing-page-video-preview-modal .vjs-fullscreen .vjs-control-bar {
      font-size: 16px;
    }
  }
`;
